import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

import type { SessionUser } from 'src/shared/session';

import { CLOSE_PETITION_ERROR_MAP } from '../constants';

import type { ClosePetitionV2Mutation, ClosePetitionV2MutationVariables } from './closePetition.graphql';
import { ClosePetitionV2 } from './closePetition.graphql';

export async function closePetition(
	{ id, user }: { id: string; user?: SessionUser },
	{ gql: { fetch }, errorReporter }: UtilityContext,
) {
	if (!user) {
		throw new Error(CLOSE_PETITION_ERROR_MAP.UNAUTHENTICATED_ERROR);
	}

	const { data } = await fetch<ClosePetitionV2Mutation, ClosePetitionV2MutationVariables>({
		query: ClosePetitionV2,
		variables: {
			input: { petitionId: id },
		},
		rejectOnError: true,
	});

	if (!data.closePetition.success) {
		// could be authentication error or status code of 400, 401, 403, 404
		const err = new Error(CLOSE_PETITION_ERROR_MAP.UNKNOWN_ERROR);
		void errorReporter.report({
			error: new Error('Failed to close petition'),
			context: {
				reason: CLOSE_PETITION_ERROR_MAP.UNKNOWN_ERROR,
			},
		});
		throw err;
	}

	return { status: 'ok' as const };
}
